import { redirect, type LoaderFunctionArgs, type RouteObject } from "react-router";
import { AppShell } from "@/components/admin/app-shell";
import { ADMIN_USAGE_PATH, adminLicensePath, adminLicensesPath } from "@/lib/navigation";
import { AuditPage } from "@/pages/audit-page";
import { CustomersPage } from "@/pages/customers-page";
import { CreateCustomerPage } from "@/pages/create-customer-page";
import { CreateProductPage } from "@/pages/create-product-page";
import { CreateLicensePage } from "@/pages/create-license-page";
import { LicenseDetailPage } from "@/pages/license-detail-page";
import { HelpPage } from "@/pages/help-page";
import { NotFoundPage } from "@/pages/not-found-page";
import { ProductsPage } from "@/pages/products-page";
import { SearchPage } from "@/pages/search-page";
import { ProductUsagePage } from "@/pages/product-usage-page";
import { ProductAnalysisPage } from "@/pages/product-analysis-page";
import { APIActivityPage } from "@/pages/api-activity-page";
import { AdminAccountsPage } from "@/pages/admin-accounts-page";

function redirectToAdminUsage() {
  return redirect(ADMIN_USAGE_PATH);
}

function redirectLegacySearch({ request }: LoaderFunctionArgs) {
  const q = new URL(request.url).searchParams.get("q");
  const hub = adminLicensesPath();
  return redirect(q ? `${hub}?${new URLSearchParams({ q })}` : hub);
}

function redirectLicenseEdit({ params }: LoaderFunctionArgs) {
  const licenseId = params.licenseId;
  if (!licenseId) return redirect(adminLicensesPath());
  return redirect(`${adminLicensePath(licenseId)}?tab=configuration`);
}

function redirectLegacyActivations({ request }: LoaderFunctionArgs) {
  const params = new URL(request.url).searchParams;
  const license = params.get("license");
  if (license) {
    const focus = params.get("focus");
    const detail = adminLicensePath(license);
    return redirect(focus ? `${detail}?${new URLSearchParams({ focus })}` : detail);
  }
  return redirect(adminLicensesPath({ product: params.get("q") ?? undefined }));
}

export const adminRoutes: RouteObject[] = [
  {
    path: "/admin",
    element: <AppShell />,
    children: [
      { index: true, loader: redirectToAdminUsage },
      { path: "enroll", element: null },
      { path: "usage", element: <ProductUsagePage /> },
      { path: "products/:productId/usage", element: <ProductAnalysisPage /> },
      { path: "search", loader: redirectLegacySearch },
      { path: "licenses", element: <SearchPage /> },
      { path: "licenses/new", element: <CreateLicensePage /> },
      { path: "licenses/:licenseId/edit", loader: redirectLicenseEdit },
      { path: "licenses/:licenseId", element: <LicenseDetailPage /> },
      { path: "product-keys", loader: redirectLegacySearch },
      { path: "activations", loader: redirectLegacyActivations },
      { path: "products", element: <ProductsPage /> },
      { path: "products/new", element: <CreateProductPage /> },
      { path: "customers", element: <CustomersPage /> },
      { path: "customers/new", element: <CreateCustomerPage /> },
      { path: "audit", element: <AuditPage /> },
      { path: "api-activity", element: <APIActivityPage /> },
      { path: "accounts", element: <AdminAccountsPage /> },
      { path: "help", element: <HelpPage /> },
      { path: "not-found", element: <NotFoundPage /> },
      { path: "*", element: <NotFoundPage /> },
    ],
  },
  { path: "*", loader: redirectToAdminUsage },
];
